import React from "react";
import { withTranslation } from "react-i18next";

import {
  Col,
  Container,
  Row
} from "react-bootstrap";
import CamplaCoreService from "../../../../services/CamplaCoreService";
import APIErrorHelper from "../../../../helpers/APIErrorHelper";
import PaginationTable from "../../../../components/paginationTable/PaginationTable";
import Button from "react-bootstrap/Button";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faCertificate,
  faPlus,
  faUser,
} from "@fortawesome/free-solid-svg-icons";
import { textFilter } from "react-bootstrap-table2-filter";
import IsolationHardwareActionCell from "./isolationHardwareActionCell/IsolationHardwareActionCell";
import CreateIsolationHardware from "./dialogs/createIsolationHardwareDialog/CreateIsolationHardware";
import StorageService from "../../../../services/StorageService";
import UnsavedChangesDialog from "../../../../components/dialogs/unsavedChangesDialog/UnsavedChangesDialog";
import PaginationTableFilterToggle
  from "../../../../components/paginationTableFilterToggle/PaginationTableFilterToggle";
import ImportIsolationHardwareDialog from "./dialogs/importIsolationHardwareDialog/ImportIsolationHardwareDialog";
import UpdateIsolationHardwareDialog from "./dialogs/updateIsolationHardwareDialog/UpdateIsolationHardwareDialog";

class IsolationHardwareTab extends React.Component {
  constructor(props) {
    super(props);
    this.tableId = "isolationHardwareTable";

    let showFilters = StorageService.tableConfigShowFilters(this.tableId);
    this.state = {
      isolationHardware: [],
      showCreateModal: false,
      showUnsavedChangesDialog: false,
      showImportModal: false,
      showUpdateModal: false,
      selectedIsolationHardware: null,
      dialogApiError: "",
      apiError: "",
      displayFilter: showFilters ? "initial" : "none",
      showFilters,
    };


    this.handleCreate = this.handleCreate.bind(this);
    this.handleUpdate = this.handleUpdate.bind(this);
    this.handleRemove = this.handleRemove.bind(this);
    this.handleImport = this.handleImport.bind(this);
    this.loadData = this.loadData.bind(this);

    this.paginationTableRef = React.createRef();
  }

  componentDidMount() {
    this.loadData();
  }

  async loadData() {
    try {
      const isolationHardware = await CamplaCoreService.getAllIsolationHardware();
      this.setState({ isolationHardware });
    } catch (err) {
      this.setState({
        apiError: APIErrorHelper.getError(
          err,
          () => this.setState({ apiError: "" }),
          {},
          this.props.t
        ),
      });
    }
  }

  async handleImport(isolationHardwareList, updateOnSerial = false){
    const importedIsolationHardware = [];
    const updatedIsolationHardware = [...this.state.isolationHardware];
    let hasErrors = false;
    for (const isolationHardware of isolationHardwareList) {
      try {
        let createdOrUpdatedIsolationHardware;
        let foundIsolationHardware = null;
        if (updateOnSerial){
          try {
            foundIsolationHardware = await CamplaCoreService.getIsolationHardwareBySerialNumber(isolationHardware.serialNumber);
          }catch (err) {}
        }

        if (foundIsolationHardware){
          Object.keys(isolationHardware).forEach((key) => {
            foundIsolationHardware[key] = isolationHardware[key];
          });
          createdOrUpdatedIsolationHardware = await CamplaCoreService.updateIsolationHardware(foundIsolationHardware._id, foundIsolationHardware);
          for (let i in updatedIsolationHardware){
            if (updatedIsolationHardware[i]._id === foundIsolationHardware._id){
              updatedIsolationHardware[i] = createdOrUpdatedIsolationHardware;
              break;
            }
          }
        }else{
          createdOrUpdatedIsolationHardware = await CamplaCoreService.createIsolationHardware(
              isolationHardware
          );
          updatedIsolationHardware.push(createdOrUpdatedIsolationHardware);
        }

        isolationHardware["errorCode"] = 0;
      }catch (err){
        if (typeof err["status"] !== "undefined") {
          isolationHardware["errorCode"] = err.status;
        }else{
          isolationHardware["errorCode"] = 500;
        }
        hasErrors = true;
      }
      importedIsolationHardware.push(isolationHardware)
    }

    this.setState({
      showImportModal: hasErrors,
      isolationHardware: updatedIsolationHardware
    });
    return {importedHardware: importedIsolationHardware, hasErrors};
  }

  async handleCreate(isolationHardware) {
    try {
      const singleIsolationHardware = await CamplaCoreService.createIsolationHardware(
        isolationHardware
      );
      this.setState({
        isolationHardware: [
          ...this.state.isolationHardware,
          singleIsolationHardware,
        ],
        showCreateModal: false,
      });
    } catch (err) {
      this.setState({
        dialogApiError: APIErrorHelper.getError(
          err,
          () => this.setState({ dialogApiError: "" }),
          {},
          this.props.t
        ),
      });
    }
  }

  async handleUpdate(isolationHardware) {
    try {
      const singleIsolationHardware = await CamplaCoreService
          .updateIsolationHardware(this.state.selectedIsolationHardware._id, isolationHardware);
      const updatedIsolationHardware = this.state.isolationHardware.map(ih => {
        if (ih._id === this.state.selectedIsolationHardware._id) {
          return singleIsolationHardware;
        }
        return ih;
      })
      this.setState({
        isolationHardware: updatedIsolationHardware,
        showUpdateModal: false,
      });
    } catch (err) {
      this.setState({
        dialogApiError: APIErrorHelper.getError(
            err,
            () => this.setState({ dialogApiError: "" }),
            {},
            this.props.t
        ),
      });
    }
  }

  async handleRemove(singleIsolationHardware) {
    try {
      await CamplaCoreService.deleteIsolationHardware(
        singleIsolationHardware._id
      );
      const isolationHardware = this.state.isolationHardware.filter(
        (i) => i._id !== singleIsolationHardware._id
      );
      this.setState({ isolationHardware });
    } catch (err) {
      this.setState({
        apiError: APIErrorHelper.getError(
          err,
          () => this.setState({ apiError: "" }),
          {},
          this.props.t
        ),
      });
    }
  }

  render() {
    const { t } = this.props;

    const columns = [
      {
        dataField: "currentInstance",
        text: "",
        sort: true,
        headerStyle: () => ({ width: "40px" }),
        csvExport: false,
        formatter: (currentInstance) => {
          return (
            <span>
              {currentInstance !== null ? (
                <FontAwesomeIcon icon={faUser} className="color-green" />
              ) : (
                <FontAwesomeIcon icon={faUser} className="color-red" />
              )}
            </span>
          );
        },
      },
      {
        dataField: "trusted",
        text: "",
        sort: true,
        headerStyle: () => ({ width: "40px" }),
        csvExport: false,
        formatter: (trusted) => {
          return (
              <span>
              {trusted ? (
                  <FontAwesomeIcon icon={faCertificate} className="color-green" />
              ) : (
                  <FontAwesomeIcon icon={faCertificate} className="color-red" />
              )}
            </span>
          );
        }
      },
      {
        dataField: "identifier",
        text: t("Hardware.Tabs.IsolationHardware.ColumnIdentifier"),
        sort: true,
        filter: textFilter({
          style: { display: this.state.displayFilter },
          placeholder: t("Hardware.Tabs.IsolationHardware.FilterIdentifierPlaceholder")
        }),
      },
      {
        dataField: "product",
        text: t("Hardware.Tabs.IsolationHardware.ColumnProduct"),
        sort: true,
        filter: textFilter({
          style: { display: this.state.displayFilter },
          placeholder: t("Hardware.Tabs.IsolationHardware.FilterProductPlaceholder")
        }),
      },
      {
        dataField: "serialNumber",
        text: t("Hardware.Tabs.IsolationHardware.ColumnSerialNumber"),
        sort: true,
        filter: textFilter({
          style: { display: this.state.displayFilter },
          placeholder: t("Hardware.Tabs.IsolationHardware.FilterSerialNumberPlaceholder")
        }),
        formatter: (serialNumber) => {
          return <span style={{ fontSize: "8pt" }}>{serialNumber}</span>;
        },
      },
      {
        dataField: "osVersion",
        text: t("Hardware.Tabs.IsolationHardware.ColumnOsVersion"),
        sort: true,
        filter: textFilter({
          style: { display: this.state.displayFilter },
          placeholder: t("Hardware.Tabs.IsolationHardware.FilterOsVersionPlaceholder")
        }),
      },
      {
        dataField: "actions",
        text: "",
        headerFormatter: () => (
            <PaginationTableFilterToggle
                onFilterToggle={(e) => {
                  this.setState({
                    showFilters: e.currentTarget.checked,
                    displayFilter: e.currentTarget.checked ? "initial" : "none",
                  });
                }}
                showFilters={this.state.showFilters}
                tableId={this.tableId} />
        ),
        headerClasses: "actionHeader",
        isDummyField: true,
        csvExport: false,
        formatter: (cell, isolationHardware) => {
          return (
            <IsolationHardwareActionCell
                onUpdate={() => {
                  this.setState({
                    selectedIsolationHardware: isolationHardware,
                    showUpdateModal: true
                  })
                }}
                onDelete={() => this.handleRemove(isolationHardware)}
            />
          );
        },
      },
    ];

    return (
      <div>
        <CreateIsolationHardware
          show={this.state.showCreateModal}
          onHide={(isFormDirty) => {
            if (isFormDirty) {
              this.setState({
                dialogApiError: null,
                showUnsavedChangesDialog: true,
                closeAction: () => this.setState({ showCreateModal: false }),
              });
            } else {
              this.setState({
                dialogApiError: null,
                showCreateModal: false,
              });
            }
          }}
          onSubmit={this.handleCreate}
          dialogApiError={this.state.dialogApiError}
        />
        <UpdateIsolationHardwareDialog
            show={this.state.showUpdateModal}
            onHide={(isFormDirty) => {
              if (isFormDirty) {
                this.setState({
                  dialogApiError: null,
                  showUnsavedChangesDialog: true,
                  closeAction: () => this.setState({ showUpdateModal: false }),
                });
              } else {
                this.setState({
                  dialogApiError: null,
                  showUpdateModal: false,
                });
              }
            }}
            isolationHardware={this.state.selectedIsolationHardware}
            onSubmit={this.handleUpdate}
            dialogApiError={this.state.dialogApiError}
        />
        <ImportIsolationHardwareDialog
            show={this.state.showImportModal}
            onHide={() => this.setState({ showImportModal: false })}
            onSubmit={this.handleImport}
        />
        <UnsavedChangesDialog
          show={this.state.showUnsavedChangesDialog}
          onHide={() => this.setState({ showUnsavedChangesDialog: false })}
          onSubmit={() => {
            this.setState({ showUnsavedChangesDialog: false });
            this.state.closeAction();
          }}
        />
        <Container className="mt-3 pl-0 pr-0">
          <Row className="pageTitle">
            <Col>
              <h2>{t("Hardware.Tabs.IsolationHardware.Title")}</h2>
            </Col>
            <Col>
              <Button
                className="btn-green floatRight"
                onClick={() => this.setState({ showCreateModal: true })}
              >
                <FontAwesomeIcon icon={faPlus} />
              </Button>
              <Button
                  className="btn-green floatRight mr-2"
                  onClick={() => this.setState({ showImportModal: true })}
              >
                {t("Hardware.Tabs.IsolationHardware.Import")}
              </Button>
            </Col>
          </Row>
          <Row>
            <Col>
              <PaginationTable
                data={this.state.isolationHardware}
                sizePerPage={10}
                paginationSize={3}
                columns={columns}
                keyField={"_id"}
                ref={this.paginationTableRef}
                id={this.tableId}
                view="isolationHardwareTab"
              />
            </Col>
          </Row>
        </Container>
      </div>
    );
  }
}

export default withTranslation()(IsolationHardwareTab);
